
import styled from "styled-components"
import { Link } from "react-router-dom"
import { CustomButton } from "../components"
import { COLORS } from "../constants"
import axios from "axios"
import { useHistory } from "react-router-dom"
import ReactModal from 'react-modal';
import { useSelector } from "react-redux"
import { useState } from "react"

const StyledGrayCard = styled.div`
    background-color: #F2F2F2;
    border-radius: 10px;
    display: flex;
    color: black;
    padding: 10px;
    justify-content: space-around;
    align-items: center;
    flex-direction: column;
    height: 150px;
    opacity: ${props => props.completed ? "0.5" : "1"};
`;

const StyledWrapper = styled.div`
   padding: 10px;
`;
const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: 10,
        border: 0,

    },
    overlay: {
        backgroundColor: "rgba(0,0,0, 0.5)",
        zIndex: 1000
    }
};
export function ChooseGameCard({ lastViewed, gameNumber, onClick, started, isTellFunctionality, selectedlevel, inPractice, completed, gameplay }) {

    const api = process.env.REACT_APP_API_URL;

    const userFullData = useSelector(state => state.auth.user)
    const [modalOpen, setModalOpen] = useState(false)
    const [data, setData] = useState()
    const history = useHistory();

    const startNewGame = () => {

        axios.get(`${api}/cp/game/get_active_game/${userFullData.user.pupil_id}`).then(res => {

            if (res.data.status_code == 1) {

                if (selectedlevel == res.data.active_game.level_no && gameNumber == res.data.active_game.game_no) {
                    history.replace(`/game/${selectedlevel}/${gameNumber}/current_game?id=${res.data.active_game_id}`)
                } else {
                    setData(res.data);
                    setModalOpen(true);
                    // alert(`You have started Level ${res.data.active_game.level_no} Game ${res.data.active_game.game_no} already. Please complete this game.`);
                }
            } else {
                axios.post(`${api}/cp/game/new_game`, {
                    pupil_id: userFullData.user.pupil_id,
                    level_no: selectedlevel,
                    game_no: gameNumber,
                    mode_id: 3
                }).then(res => {
                    const result = res.data;
                    if (result.status == "error")
                        alert(result.message)

                    else
                        history.replace(`/game/${selectedlevel}/${gameNumber}/current_game?id=${result.new_game_id}`)

                }).catch(error => {
                    console.log(error)
                    alert("OOPS, error occured. Try to reload a page.")

                });
            }
        }).catch(err => {
            alert("OOPS, error occured. Try to reload a page.")
        })

    }
    const startPracticeGame = () => {
        if (inPractice) {
            window.location.replace(`/practice/${selectedlevel}/${gameNumber}`)
        } else {
            history.push(`/practice/${selectedlevel}/${gameNumber}`)
        }
    }
    return (
        <>
            <ReactModal ariaHideApp={false} isOpen={modalOpen} contentLabel="Error" role="dialog" style={customStyles} onRequestClose={() => setModalOpen(false)}>
                <div className="d-flex flex-column align-items-center">
                    <h5>Incompleted Game Detected</h5>
                    {data && <div className="text-center">You have started <span className="color-orange">Level {data.active_game.level_no} • Game  {data.active_game.game_no}</span> already. <br></br>Please complete this game.</div>}

                    <CustomButton
                        style={{ width: "100%", marginTop: 10 }}
                        color={COLORS.text_dark_green}
                        bgColor={COLORS.green}
                        hover={COLORS.text_green}
                        onClick={() => history.replace(`/game/${data.active_game.level_no}/${data.active_game.game_no}/current_game?id=${data.active_game_id}`)}
                    >
                        Play Game
                    </CustomButton>
                    <CustomButton
                        style={{ width: "100%", marginTop: 10 }}
                        color={COLORS.dark_orange}
                        bgColor={COLORS.orange}
                        hover={COLORS.orange_hover}
                        onClick={() => setModalOpen(false)}
                    >
                        Close
                    </CustomButton>

                </div>
            </ReactModal>
            <StyledWrapper className="small-grid-card">
                <StyledGrayCard completed={completed}>
                    <h5 className="color-dark-orange">Game {gameNumber}</h5>

                    {isTellFunctionality ?
                        <CustomButton disabled={completed} bgColor={COLORS.orange} color={COLORS.dark_orange} hover={COLORS.orange_hover} style={{ height: 40, fontSize: 15, width: 120 }} onClick={startNewGame}>{started == 1 && !completed ? "Continue" : "Play Game"}</CustomButton>
                        :
                        <>
                            {lastViewed != 'null' && <span className="text-center color-text-grey" style={{ fontSize: 14 }}>Practised <br></br>{lastViewed.substring(0, 10)}</span>}
                            <CustomButton bgColor={COLORS.orange} color={COLORS.dark_orange} hover={COLORS.orange_hover} style={{ height: 40, fontSize: 15, width: 120 }} onClick={startPracticeGame}>Play Game</CustomButton>

                        </>
                    }

                </StyledGrayCard>
            </StyledWrapper>
        </>
    );
}